import { createContext, useContext } from "react";

export const LangCtx = createContext(null);
export const useLang = () => useContext(LangCtx);

export const scrollToId = (id) => {
  if (id === "top") return window.__lenis ? window.__lenis.scrollTo(0) : window.scrollTo({ top: 0, behavior: "smooth" });
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70, duration: 1.6 });
  else el.scrollIntoView({ behavior: "smooth" });
};
